<div class="flex-container">
    <div class="flex-item">
      <img
        class="logo"
        src="../../../../../assets/WhatNow-logo-version1_rev_2.jpg"
      />
    </div>
    <div class="change-bg flex-item">
    <div class="example-container ">
        <h3>Welcome,</h3>
        <h3>Please enter the details to Sign up.</h3>
        <form [formGroup]="signupForm" (ngSubmit)="handleSignUp()">
          <mat-form-field appearance="fill">
            <mat-label >First Name</mat-label>
            <input matInput formControlName="first_name" required>
          </mat-form-field>
          <br>
          <mat-form-field appearance="fill">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="last_name" required>
          </mat-form-field>
          <br>
          <mat-form-field appearance="fill">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone" required>
          </mat-form-field>
          <br>
          <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" required>
          </mat-form-field>
          <br>
          <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" required>
          </mat-form-field>
          <br>
          <button mat-raised-button color="primary" [disabled]="!signupForm.valid">SignUp</button>
          <br><br>
        </form>
        <h5>Already have an account <span style="text-decoration: underline; cursor: pointer;" (click)=swichBetweenLoginSignup()>Sign In.</span></h5>
    </div>
    </div>
  </div>
  
  